import React from 'react';

// Tiempos de "Armar día" (25-oct-2026): cuánto lleva cada trabajo (por equipo), acomodarse en cada lugar,
// estacionar la camioneta y hasta qué hora se trabaja, según la zona.
const INPUT = 'h-10 px-3 rounded-xl bg-chip text-ink text-body font-bold outline-none w-full';
const caja = 'p-3.5 rounded-2xl bg-card border border-black/[0.07] dark:border-white/[0.07] space-y-2.5';
const ROT = 'block text-label font-black uppercase tracking-widest text-muted mb-1';
const TRABAJOS = [['INSTALACION', 'Instalación'], ['LIMPIEZA', 'Limpieza'], ['REPARACION', 'Pérdida / no enfría'], ['RETIRO', 'Retiro']];
const ZONAS = [['CABA', 'CABA'], ['SUR', 'Zona sur'], ['OTRA', 'Otras']];
const DIAS = [['LUNES', 'Lun'], ['MARTES', 'Mar'], ['MIERCOLES', 'Mié'], ['JUEVES', 'Jue'], ['VIERNES', 'Vie'], ['SABADO', 'Sáb']];
const ZONAS_DIA = [['CABA', 'CABA'], ['SUR', 'Sur'], ['OTRA', 'Otras'], ['LIBRE', 'Libre'], ['NO', 'No']];

export default function TiemposArmarDia({ c, set }) {
    const setDe = (k, clave, v) => set(k, { ...(c[k] || {}), [clave]: v });
    const num = v => v.replace(/[^\d]/g, '');
    return (
        <div className={caja}>
            <p className="text-body font-black text-ink">Armar día</p>
            <p className="text-label text-muted">En cada lugar: acomodarse una vez + el trabajo de cada equipo. En camioneta se suma estacionar en la zona a la que llegás.</p>
            <div className="grid grid-cols-2 gap-2">
                {TRABAJOS.map(([k, label]) => (
                    <label key={k} className="block">
                        <span className={ROT}>{label} (min)</span>
                        <input value={c.minutosTrabajo?.[k] ?? ''} onChange={e => setDe('minutosTrabajo', k, num(e.target.value))} inputMode="numeric" className={INPUT} />
                    </label>
                ))}
                <label className="block">
                    <span className={ROT}>Acomodarse (min)</span>
                    <input value={c.acomodarMin ?? ''} onChange={e => set('acomodarMin', num(e.target.value))} inputMode="numeric" className={INPUT} />
                </label>
            </div>
            <div className="space-y-1.5">
                <div className="grid grid-cols-[1fr_1fr_1fr] gap-2 text-label font-black uppercase tracking-widest text-muted">
                    <span>Zona</span><span>Estacionar</span><span>Hasta</span>
                </div>
                {ZONAS.map(([k, label]) => (
                    <div key={k} className="grid grid-cols-[1fr_1fr_1fr] gap-2 items-center">
                        <span className="text-body font-bold text-ink">{label}</span>
                        <input value={c.estacionarMin?.[k] ?? ''} onChange={e => setDe('estacionarMin', k, num(e.target.value))} inputMode="numeric" aria-label={`Estacionar en ${label} (min)`} className={INPUT} />
                        <input type="time" value={c.finJornadaZona?.[k] ?? ''} onChange={e => setDe('finJornadaZona', k, e.target.value)} aria-label={`Fin de jornada en ${label}`} className={INPUT} />
                    </div>
                ))}
                <p className="text-label text-muted">Las llegadas se ofrecen en las franjas de 8 a 16; el último trabajo puede terminar hasta la hora de cada zona.</p>
            </div>
            <div className="space-y-1.5 pt-1">
                <p className="text-body font-black text-ink">Semana tipo</p>
                <p className="text-label text-muted">Qué zona se trabaja cada día. Es lo que la empresa ve para reservar; un día puntual se cambia en Trabajos → Semana.</p>
                {DIAS.map(([d, label]) => (
                    <div key={d} className="flex items-center gap-2">
                        <span className="w-10 shrink-0 text-body font-bold text-ink">{label}</span>
                        <select value={c.semanaZonas?.[d] || 'LIBRE'} onChange={e => setDe('semanaZonas', d, e.target.value)} aria-label={`Zona del ${label}`} className={INPUT}>
                            {ZONAS_DIA.map(([z, zl]) => <option key={z} value={z}>{zl === 'No' ? 'No se trabaja' : zl === 'Libre' ? 'Cualquier zona' : zl}</option>)}
                        </select>
                    </div>
                ))}
                <div className="grid grid-cols-3 gap-2 pt-1">
                    <label className="block"><span className={ROT}>Equipos por día</span>
                        <input value={c.cupoDia ?? ''} onChange={e => set('cupoDia', num(e.target.value))} inputMode="numeric" className={INPUT} /></label>
                    <label className="block"><span className={ROT}>Para urgencias</span>
                        <input value={c.reservaUrgencias ?? ''} onChange={e => set('reservaUrgencias', num(e.target.value))} inputMode="numeric" className={INPUT} /></label>
                    <label className="block"><span className={ROT}>Cierre</span>
                        <input type="time" value={c.horaCierre ?? '17:30'} onChange={e => set('horaCierre', e.target.value)} className={INPUT} /></label>
                </div>
                <label className="flex items-center gap-3 pt-1">
                    <input type="checkbox" checked={!!c.cierreAutomatico} onChange={e => set('cierreAutomatico', e.target.checked)} className="w-5 h-5 accent-[#C9341F]" />
                    <span className="text-body font-bold text-ink">Cierre automático</span>
                </label>
                <p className="text-label text-muted">Prendido: a la hora de cierre se arma el día siguiente con lo reservado y cada pedido queda agendado con su franja. Apagado: lo cerrás vos desde Trabajos → Semana.</p>
            </div>
        </div>
    );
}
